import { Formik, FormikProps } from "formik";
import { useCallback, useEffect } from "react";
import {
  IResetPasswordFormValues,
  resetPasswordValidationSchema,
} from "../../../../../common/validations/members-access.validations";
import { CallToast } from "../../../../PriceCalculator/modals/CustomToast";

interface ResetPasswordFormHandlers {
  handleCopyPassword: () => Promise<void>;
  handleTemporaryPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface ResetPasswordFormChildrenProps
  extends FormikProps<IResetPasswordFormValues>,
    ResetPasswordFormHandlers {}

interface ResetPasswordFormProps {
  initialValues: IResetPasswordFormValues;
  onFormStateChange?: (values: IResetPasswordFormValues, isValid: boolean) => void;
  children: (props: ResetPasswordFormChildrenProps) => React.ReactNode;
}

interface FormContentProps {
  formikProps: FormikProps<IResetPasswordFormValues>;
  onFormStateChange?: (values: IResetPasswordFormValues, isValid: boolean) => void;
  children: (props: ResetPasswordFormChildrenProps) => React.ReactNode;
}

const FormContent = ({
  formikProps,
  onFormStateChange,
  children,
}: FormContentProps) => {
  const { values, isValid, setFieldValue } = formikProps;

  useEffect(() => {
    if (onFormStateChange) {
      onFormStateChange(values, isValid);
    }
  }, [values, isValid, onFormStateChange]);

  const handleCopyPassword = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(values.temporaryPassword);
      CallToast("Password copied to clipboard", false, false, "v2style");
    } catch (err) {
      console.error("Failed to copy password:", err);
      throw err;
    }
  }, [values.temporaryPassword]);

  const handleTemporaryPasswordChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("temporaryPassword", e.target.value);
  }, [setFieldValue]);

  return (
    <>
      {children({ ...formikProps, handleCopyPassword, handleTemporaryPasswordChange })}
    </>
  );
};

const ResetPasswordFormWrapper = ({
  initialValues,
  onFormStateChange,
  children,
}: ResetPasswordFormProps) => {
  const handleSubmit = (values: IResetPasswordFormValues) => {
    
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={resetPasswordValidationSchema}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnMount={true}
    >
      {(formikProps) => (
        <FormContent
          formikProps={formikProps}
          onFormStateChange={onFormStateChange}
          children={children}
        />
      )}
    </Formik>
  );
};

export default ResetPasswordFormWrapper;

